<script>
	import LoginForm from "$lib/sections/Admin/LoginForm.svelte";

	export let data;
	export let lang;
</script>

<LoginForm {data} {lang} />
